import React from "react";
import Video from "../../main/Video";
import BackButton from "../../main/BackButton";

const NowSellingOnWhatnot = () => {
  return (
    <>
      <BackButton url="/allvideos" />
      <Video
        url="https://yuriy-dmytrash19.wistia.com/medias/c567dfj6ue"
        maxHeight="80%"
      />
    </>
  );
};

export default NowSellingOnWhatnot;
